import { useRef } from 'react';
import { useInView } from '@/hooks/useInView';

interface LazyInViewProps {
  children: React.ReactNode;
  rootMargin?: string;
  onlyOnce?: boolean;
  placeholder?: React.ReactNode;
}

export const LazyInView = ({
  children,
  rootMargin = '600px',
  onlyOnce = true,
  placeholder = null,
}: LazyInViewProps) => {
  const ref = useRef<HTMLDivElement>(null);

  const inView = useInView(ref, {
    rootMargin,
    onlyOnce,
  });

  return <div ref={ref}>{inView ? children : placeholder}</div>;
};
